import { createCookie, eraseCookie, readCookie } from '@paragon/client-tools';

// These methods exist here instead of @paragon/dev-tools in order to prevent a circular dependency

const ENVIRONMENT_COOKIE = '__PARAGON_ENVIRONMENT';

export function getEnvironmentOverride(): string | null {
  if (process.env.PRODUCTION) {
    return null;
  }

  return readCookie(ENVIRONMENT_COOKIE);
}

export function setEnvironmentOverride(environment: string, reload = true) {
  createCookie(ENVIRONMENT_COOKIE, environment, { domainSpecific: true });

  if (reload) {
    window.location.reload();
  }
}

export function clearEnvironmentOverride(reload = true) {
  eraseCookie(ENVIRONMENT_COOKIE, { domainSpecific: true });

  if (reload) {
    window.location.reload();
  }
}
